<div class="actions flex justify-end gap-4">
  <button
    type="button"
    class="flex flex-shrink-0 items-center gap-3"
    [routerLink]="[patientId, routes.charting]"
    [ffdPushTagOnClick]="{
      event: TagEvent.ChartingOpened,
      location: 'patient_search',
      patient_id: patientId
    }"
  >
    <h4 class="ml-3 text-h4 font-semibold text-primary-blue">{{ 'patientSearch_chart_button' | translate }}</h4>
    <div
      class="flex h-10 w-10 items-center justify-center rounded-2xl border border-primary-blue bg-background-white drop-shadow-icon-button"
    >
      <svg-icon class="text-primary-blue" key="px-24-chart" size="md"></svg-icon>
    </div>
  </button>
</div>
